/**
 * PresentationAbstractView React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


import React from 'react';
import {withStyles} from "@material-ui/core";
import PropTypes from 'prop-types';
import {getMediaUrl} from '../../../operations/utils';
import PresentationSlideView from "./PresentationSlideView";
import PresentationTitle from "./PresentationTitle";
import MajusculeText from "./MajusculeText";
import AnimatedUpdate from "../../animation/AnimatedUpdate";
import ParagraphText from "../../base/ParagraphText";
import {getHorizontalAnimate, getStandardTransition} from "./animationUtils";


/**
 * PresentationAbstractView
 *
 * @author Jens Gruschel
 */
function PresentationAbstractView(props) {

    const presentationFileOrFolder = props.presentationFileOrFolder || {};
    const presentationFileOrFolderFields = presentationFileOrFolder.fields || {};

    const imageItem = props.findReferencedObjects(presentationFileOrFolderFields['image']);
    const teaser = presentationFileOrFolderFields.teaser;

    // note that teaser and title are swapped in this view

    const titleElement = <AnimatedUpdate tag={teaser} order={props.index} animate={getHorizontalAnimate()} transition={getStandardTransition(0.5)}>
        <div className={props.classes.topAlignedTeaser}><MajusculeText text={teaser} /></div>
    </AnimatedUpdate>;

    const teaserElement = <PresentationTitle
        className={props.classes.bottomAlignedTeaser}
        title={presentationFileOrFolderFields.title}
        subheading={presentationFileOrFolderFields.subheading}
    />;

    const chapterElement = <div className="presentation-chapter-text">
        <ParagraphText text={presentationFileOrFolderFields.abstract} />
    </div>;

    const slideData = {
        titleElement: titleElement,
        teaserTag: "title:" + presentationFileOrFolderFields.title + ";subheading:" + presentationFileOrFolderFields.subheading,
        teaserElement: teaserElement,
        teaserImageUrl: getMediaUrl(imageItem) || presentationFileOrFolder.imageurl,
        chapterTitle: null,
        chapterTag: "text:" + presentationFileOrFolderFields.abstract,
        chapterElement: chapterElement,
        chapterImageUrl: null
    };

    return <PresentationSlideView
        screenIndex={props.screenIndex}
        data={slideData}
    />;
}

PresentationAbstractView.propTypes = {
    screenIndex: PropTypes.number,
    presentationFileOrFolder: PropTypes.object,
    index: PropTypes.number, // only required if animation between multiple presentation files or folders is needed
    findReferencedObjects: PropTypes.func.isRequired
};

const styles = theme => ({
    topAlignedTeaser: {
        position: "absolute",
        top: "0vw",
        left: "8vw",
        width: "84vw"
    },
    bottomAlignedTeaser: {
        position: "absolute",
        bottom: "0vw",
        left: "8vw",
        width: "84vw"
    }
});

export default withStyles(styles)(PresentationAbstractView);
